import BlockList from './BlockList';
import BlockEdit from './BlockEdit';
import BlockCreate from './BlockCreate';

export default {
  name: 'whatsapp_block',
  list: BlockList,
  edit: BlockEdit,
  create: BlockCreate,
};
